export default "__VITE_ASSET__CeniC_hh__"